/**
 * Conjunto de resultados
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
import KeyValuePair from '@/modules/core/support/KeyValuePair';
import OmnisearchResultItem from '@/modules/omnisearch/store/OmnisearchResultItem';

export default class OmnisearchResultSet {
    /**
     * Tipo del conjunto de resultados
     *
     * @var { string }
     */
    public type = ''

    /**
     * Total de resultados coincidentes con el termino de búsqueda
     *
     * @var { number }
     */
    public totalCount = 0

    public items: OmnisearchResultItem[] = []

    public static deserialize (data: KeyValuePair) {
        return Object.assign(new this(), {
            type: data.type,
            totalCount: data.total_count,
            items: data.items.map((item: KeyValuePair) => OmnisearchResultItem.deserialize(item)),
        })
    }
}
